import { DataRoomObjectFragment } from '../../graphql/generated';

export const getAvailableDataRooms = <
  T extends { dataRooms: { objects: DataRoomObjectFragment[] } }
>(data?: {
  dataRoomCategories: T[];
}) =>
  data?.dataRoomCategories.flatMap(({ dataRooms }) => dataRooms.objects) || [];
